<script setup lang="ts">
import merge from 'lodash-es/merge';
import type { ListItemModel } from '#layers/prawopl/app/pages/cms/modules/wk-surveys/_runtime/services/SurveysService';
import SurveysService from '#layers/prawopl/app/pages/cms/modules/wk-surveys/_runtime/services/SurveysService';

defineOptions({
    name: 'WkSurveySettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue',): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const defaults = ref<any>({
    page: null
});

const form = computed<FormType<any>>(() =>
{
    return props.modelValue;
});

watch(() => form.value.settings, () =>
{
    triggerModel();
},
{ deep: true });

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

async function validate(): Promise<void>
{
    form.value.validate(schema => ({
        settings: schema.object({
            survey: schema.string().nullable().required($t('[[[Wybranie ankiety jest wymagane]]]'))
        })
    }));
}

async function fetchSurvey(id: number): Promise<ListItemModel>
{
    if (id != 0)
    {
        const response = await SurveysService.fetchAutocompleteModel(id);

        return response || null;
    }

    return null;
}

async function searchSurveys(query: string, limit: number): Promise<ListItemModel[]>
{
    return await SurveysService.getAutocompleteList(query, limit);
}
onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});

defineExpose({
    validate
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Ankieta]]]')" :invalid-feedback="form.$errors.first('settings.survey')" :state="form.$errors.state('settings.survey')" required>
        <IdeoAutocomplete
            v-model="form.settings.survey"
            name="settings.survey"
            track-by="revisionOrigin"
            :placeholder="$t('[[[zacznij pisać aby wyszukać ankietę...]]]')"
            :fetch="(id: number) => fetchSurvey(id)"
            :search="(query: string, limit: number) => searchSurveys(query, limit)"
            :disabled="form.language === null"
        >
            <template #selected="{ option }">
                <div class="text-wrap">
                    {{ option.question }}
                </div>
            </template>
            <template #option="{ option }">
                <div class="text-wrap">
                    {{ option.question }}
                </div>
            </template>
        </IdeoAutocomplete>
    </IdeoFormGroup>
</template>
